import { FC } from 'react';
import { SizeTableTypeProps } from './TypeProps';
import { WrapperFrame } from '@app/shared/ui/Wrappers';
import { HTag } from '@ui-kit/MyHtag';
import { LinkColors, MyLink } from '@app/shared';
import { useAppSelector } from '@redux/hooks';
import classNames from 'classnames';

import styles from './SizeTable.module.scss';

export const SizeTable: FC<SizeTableTypeProps> = ({ className, list, title }) => {
  const host = useAppSelector(state => state.header.data.host);
  return (
    <WrapperFrame className={classNames(styles.WrapperCarsTable, className)}>
      {title && <HTag tag={'h3'}>{title}</HTag>}
      <div className={styles.Container}>
        {list?.map(size => {
          return (
            <div className={styles.WrapperItem} key={size?.title}>
              <div className={styles.Title}>{size?.title}</div>
              <div className={styles.Items}>
                {size?.tags?.map(item => {
                  return (
                    <MyLink reloaded color={LinkColors.Black} key={item?.href || ''} href={`${host}${item?.href}`}>
                      {item?.title}
                    </MyLink>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </WrapperFrame>
  );
};
